export class Grupo {
  id: string;
  idFormulario: string;
  ordem: string;
  descricao: string;
}